import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { FaCookieBite } from 'react-icons/fa';

const STORAGE_KEY = 'chopsticks-cookie-consent';

/**
 * Cookie lišta v rohu webu (GDPR-friendly).
 * Volba (all | essential) se uloží do localStorage; po uložení se už nezobrazuje.
 * Ostatní skripty si mohou souhlas přečíst přes:  localStorage.getItem('chopsticks-cookie-consent')
 */
export default function CookieConsent() {
  const reduce = useReducedMotion();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) { /* ignore */ }
    if (!stored) {
      const t = setTimeout(() => setShow(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* ignore */ }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          role="dialog"
          aria-live="polite"
          aria-label="Souhlas s používáním cookies"
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduce ? { opacity: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-[55] bg-ink-800/95 backdrop-blur-xl border border-line rounded-2xl shadow-2xl p-5"
        >
          <div className="flex items-center gap-3 mb-3">
            <span className="w-10 h-10 rounded-full bg-gold/15 border border-gold/25 flex items-center justify-center text-gold flex-shrink-0">
              <FaCookieBite />
            </span>
            <h3 className="font-cormorant text-xl font-bold text-main-text">Cookies</h3>
          </div>
          <p className="text-main-text/60 text-sm font-jost font-light leading-relaxed mb-4">
            Používáme nezbytné cookies pro fungování webu a zabezpečení plateb. S vaším souhlasem
            i další, které nám pomáhají web vylepšovat.
          </p>
          <div className="flex flex-col sm:flex-row gap-2.5">
            <button
              onClick={() => decide('all')}
              className="flex-1 bg-gold text-ink-900 font-jost font-bold text-xs uppercase tracking-widest px-4 py-3 rounded-full shadow-gold-sm hover:shadow-gold transition-all duration-300"
            >
              Přijmout vše
            </button>
            <button
              onClick={() => decide('essential')}
              className="flex-1 border border-main-text/25 text-main-text/80 hover:border-gold hover:text-gold font-jost font-bold text-xs uppercase tracking-widest px-4 py-3 rounded-full transition-colors duration-300"
            >
              Jen nezbytné
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
